module.exports = __webpack_public_path__ + "img/tu17.89488ac4.png";